import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  Divider,
  Input,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
const userTypes = ["customer", "staff", "manager", "admin", "administrator"];
const userTypeEN = ["عميل", "موظف", "مدير", "مشرف", "مسؤول"];
const AddUserForm = ({ onClose, onSuccess, initialData }) => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   password: "",
  //   password_confirmation: "",
  //   phone: "",
  //   type: "",
  //   avatar: null,
  // });
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    email: initialData?.email || "",
    password: "",
    password_confirmation: "",
    phone: initialData?.phone || "",
    type: initialData?.type || "staff",
    avatar: null,
    id: initialData?.id || null, // Add ID field
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name,
        email: initialData.email,
        phone: initialData.phone,
        type: initialData.type,
        avatar: initialData.avatar, // Keep as string for existing images
        id: initialData.id,
        password: "",
        password_confirmation: "",
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!validateEmail(formData.email)) newErrors.email = "بريد إلكتروني غير صالح";

    if (!formData.id) {
      if (!validateRequired(formData.password)) newErrors.password = "يجب إدخال كلمة السر";
      if (!validatePasswordMatch(formData.password, formData.password_confirmation))
        newErrors.confirmPassword = "كلمة السر غير متطابقة";
    }
    // if (!validateRequired(formData.phone)) newErrors.phone = "يجب إدخال الهاتف";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && ["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      setFormData((prev) => ({ ...prev, avatar: file }));
      setErrors((prev) => ({ ...prev, avatar: "" }));
    } else {
      setErrors((prev) => ({ ...prev, avatar: "يجب أن تكون الصورة بصيغة PNG, jpeg, أو GIF" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          if (key === "avatar") {
            // Only append new files, keep existing path if no new file
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/manager/users/update/${formData.id}`
        : BASE_URL + "/manager/users/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      phone: "",
      type: "staff",
      avatar: null,
    });
    setErrors({});
    onClose();
  };
  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, avatar: null }));
  };
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        maxWidth: 600,
        width: { xs: "100%", sm: 500, md: 600 },
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        mx: "auto",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل المستخدم" : "إضافة مستخدم جديد"}
        </Typography>
      </Box>

      {/* Main Form */}
      <Grid container spacing={3}>
        {/* Left Column */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            المعلومات الأساسية
          </Typography>

          <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
            <TextField
              label="الاسم الكامل *"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
          </FormControl>

          <FormControl fullWidth error={!!errors.email} sx={{ mb: 2 }}>
            <TextField
              label="البريد الإلكتروني *"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
            />
          </FormControl>

          <FormControl fullWidth error={!!errors.phone} sx={{ mb: 2 }}>
            <TextField
              label="رقم الهاتف *"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
            />
          </FormControl>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            إعدادات الحساب
          </Typography>
          <FormControl fullWidth error={!!errors.password} sx={{ mb: 2 }}>
            <TextField
              label="كلمة المرور *"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
            />
          </FormControl>

          <FormControl fullWidth error={!!errors.confirmPassword} sx={{ mb: 2 }}>
            <TextField
              label="تأكيد كلمة المرور *"
              name="password_confirmation"
              type="password"
              value={formData.password_confirmation}
              onChange={handleChange}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* Image Upload Section */}
      <Box mt={3}>
        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
          صورة المستخدم
        </Typography>
        <Input
          type="file"
          inputProps={{ accept: "image/png, image/jpeg, image/gif" }}
          onChange={handleImageChange}
          sx={{ display: "none" }}
          id="image-upload"
          name="avatar"
        />
        <Box display="flex" justifyContent={{ xs: "center", sm: "flex-start" }}>
          <label htmlFor="image-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: { xs: "100%", sm: 200 }, color: "red", mt: 1 }}
            >
              تحميل الصورة
            </Button>
          </label>
        </Box>
        {formData.avatar && (
          <Box
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-end" }}
            alignItems="center"
            mt={2}
          >
            <Avatar
              src={
                typeof formData.avatar === "string"
                  ? `https://back.al-balad.sa/uploads/users/avatars/${formData.avatar}`
                  : URL.createObjectURL(formData.avatar)
              }
              sx={{
                width: 100,
                height: 100,
                border: "2px solid #ddd",
              }}
            />
          </Box>
        )}
        <Typography variant="caption" color="textSecondary" display="block" mt={1}>
          (PNG, JPG, GIF فقط)
        </Typography>
        <FormHelperText error>{errors.image}</FormHelperText>
      </Box>

      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddUserForm;
